import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';

export default function AppointmentListModal({ toggle, data, onClose }) {
  const columns = useMemo(
    () => [
      {
        field: 'label',
        headerName: 'MD Name',
        flex: 1,
        minWidth: 300,
      },
      {
        field: 'date_scheduled',
        headerName: 'Appointment Date',
        flex: 1,
        minWidth: 150,
        type: 'date',
        renderCell: ({ row }) => moment(row.date_scheduled).format('DD/MM/YYYY'),
      },
      {
        field: 'date_time_scheduled',
        headerName: 'Appointment Time',
        flex: 1,
        minWidth: 150,
        renderCell: ({ row }) => moment(row.date_time_scheduled).format('hh:mm A'),
      },
    ],
    [],
  );

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={toggle} fullWidth maxWidth='md'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Appointments
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div style={{ marginBottom: 3, height: '550px', position: 'relative' }}>
          <DataGrid
            rows={data}
            rowCount={data.length}
            columns={columns}
            pageSize={50}
            disableSelectionOnClick
            getRowId={(row) => row.appointment_id}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AppointmentListModal.defaultProps = {
  toggle: false,
  data: [],
  onClose: () => {},
};

AppointmentListModal.propTypes = {
  toggle: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      date_scheduled: PropTypes.string.isRequired,
      date_time: PropTypes.string,
    }),
  ),
  onClose: PropTypes.func,
};
